import { render, staticRenderFns } from "./IconPaymentCard.vue?vue&type=template&id=112b84e9&scoped=true"
import script from "./IconPaymentCard.vue?vue&type=script&lang=js"
export * from "./IconPaymentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112b84e9",
  null
  
)

export default component.exports